import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import Wrapper from "./Components/Wrapper/Wrapper";

ReactDOM.render(
  <Wrapper>
    <App />
  </Wrapper>,
  document.getElementById("root")
);
